<template>
  <div class="tags-panel">
    <div class="tags-panel__chips">
      <hx-chip
        v-for="(tag, i) in localTags"
        :key="i"
        :color="tag.color"
        :label="tag.label"
        :type="tag.removable ? 'input' : 'action'"
        :show-right-icon="tag.removable"
        @dismiss="removeTag(i)"
      />
    </div>
    <hx-input-field v-model:input="newTag" label="Add tag" placeholder="Select..." />
  </div>
</template>

<script>
export default {
  name: 'TagsPanel',
  props: {
    tags: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localTags: [...this.tags],
      newTag: ''
    };
  },
  methods: {
    removeTag(index) {
      this.localTags.splice(index, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.tags-panel {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.tags-panel__chips {
  display: flex;
  flex-wrap: wrap;
  row-gap: 12px;
  column-gap: 8px;
  width: 100%;
}

// HxInputField draws a focus ring 5px outside the field; inset it so the ring
// isn't clipped by the cs-nav-list body's overflow.
.tags-panel :deep(.hx-input) {
  margin: 0 6px 6px;
}
</style>
